/**
 * Where the company switcher should land, given the path after
 * `/company/:id/`. A page that names one record (a review, a rule, a
 * reconciliation) belongs to the company being left, so it drops to that
 * section's list; every other page carries over unchanged.
 */
const RECORD_PAGES: ReadonlyArray<readonly [prefix: string, list: string]> = [
	["reconciles/results", "reconciles/dashboard"],
	["reconciles/mapping-rules/", "reconciles/mapping-rules"],
	["reconcile/result", "reconcile"],
	["review/result", "review/history"],
	["review/rules/", "review"],
	["review/summary/", "review/summary"],
];

export function companySwitchPath(currentPath: string): string {
	const record = RECORD_PAGES.find(([prefix]) =>
		currentPath.startsWith(prefix),
	);
	return record ? record[1] : currentPath;
}
